import type { Module } from '@/types/module';
import { API_BASE_URL } from '@/lib/config';
import { authFetch } from '@/lib/authFetch';

export const moduleService = {
  async getModules(): Promise<Module[]> {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }
    const response = await authFetch(`${API_BASE_URL}/module/GetModules`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch user modules');
    }

    return response.json();
  },

  async getModule(moduleId: string): Promise<Module> {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }
    const response = await authFetch(`${API_BASE_URL}/module/${moduleId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch module');
    }

    return response.json();
  },

  async assignUserToModule(moduleId: string, userId: string): Promise<void> {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }
    const response = await authFetch(`${API_BASE_URL}/module/${moduleId}/assign/${userId}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to assign user to module');
    }
  },

  async removeUserFromModule(moduleId: string, userId: string): Promise<void> {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }
    const response = await authFetch(`${API_BASE_URL}/module/${moduleId}/unassign/${userId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to remove user from module');
    }
  },
};
